import React, { useState, useEffect } from 'react'
import { STORAGE_USER_TOKEN_KEY } from '../../types/user'
import * as pbi from 'powerbi-client'
import Splash from '../../components/Splash'

const PowerBiEmbed = () => {
  const [embedInfo, setEmbedInfo] = useState<{
    accessToken: string
    embedUrl: string
  } | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchEmbedInfo = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem(STORAGE_USER_TOKEN_KEY)

        if (!token) {
          throw new Error('Authentication token not found.')
        }

        const response = await fetch('/api/powerbi/embed_info', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(
            errorData.error || 'Failed to fetch Power BI embed info.',
          )
        }

        const data = await response.json()
        setEmbedInfo(data)
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchEmbedInfo()
  }, [])

  useEffect(() => {
    if (embedInfo) {
      const models = pbi.models
      const embedConfig = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: embedInfo.accessToken,
        embedUrl: embedInfo.embedUrl,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: true },
          },
          background: models.BackgroundType.Transparent,
        },
      }
      const reportContainer = document.getElementById('report-container')
      ; (window as any).powerbi.embed(reportContainer, embedConfig)
    }
  }, [embedInfo])

  return (
    <div
      id="report-container"
      style={{ width: '100%', height: 'calc(100vh - 170px)' }}
    >
      {!embedInfo && loading && (
        <Splash isLoading={loading} bgColor="#F2F6FA" />
      )}
    </div>
  )
}

export default PowerBiEmbed
